<form class="p-6 pt-4 max-w-[400px]" [formGroup]="releasePayoutFormGroup">
    <h3 class="text-xl mb-2">{{ 'seasons.season-overview.dialogs.release-payout-dialog.title' | translate }}</h3>
    <p class="text-base mb-4">{{ 'seasons.season-overview.dialogs.release-payout-dialog.description' | translate }}</p>

    <sh-datepicker
        [label]="'seasons.season-overview.dialogs.release-payout-dialog.payout-cut-off-date' | translate"
        [value]="releasePayoutFormGroup.controls.payoutCutOffDate.value ?? undefined"
        [error]="!!payoutCutOffDateErrorSignal()"
        [errorMessage]="payoutCutOffDateErrorSignal() | translate"
        (value-changed)="onDateChanged($event)"
        format="DDMMYYYY"
        separator="."
    />

    <sh-input-text
        [formControl]="releasePayoutFormGroup.controls.confirmPayout"
        class="mt-4"
        [label]="'seasons.season-overview.dialogs.release-payout-dialog.confirm-label' | translate"
        [error]="!!confirmPayoutErrorSignal()"
        [errorMessage]="confirmPayoutErrorSignal() | translate"
    />

    <div class="flex justify-end items-center gap-2 mt-8">
        <sh-button
            color="secondary"
            icon="arrow-line-left-s"
            iconPosition="left"
            layout="compact"
            (clicked)="onClose()"
            [ariaLabel]="'seasons.season-overview.dialogs.release-payout-dialog.cancel' | translate"
            [label]="'seasons.season-overview.dialogs.release-payout-dialog.cancel' | translate"
        />
        <sh-button
            icon="arrow-line-right-s"
            iconPosition="left"
            layout="compact"
            (clicked)="onClose('confirm')"
            [disabled]="!canConfirm()"
            [ariaLabel]="'seasons.season-overview.dialogs.release-payout-dialog.release-payout' | translate"
            [label]="'seasons.season-overview.dialogs.release-payout-dialog.release-payout' | translate"
        />
    </div>
</form>
